exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-link-presenter{color:#b52372;cursor:pointer;text-decoration:underline;font-weight:normal;margin-right:5px;display:inline}.c-link-presenter_icon{vertical-align:middle;display:inline}", ""]);

// exports
